
import { Component, Vue, Watch } from "vue-property-decorator";
import { API_ROUTES } from "@/utils/API";
import { TCompanies_Highlight } from "@/models/companies_highlight";

import {
  NOT_COMPLIANT,
  COMPLIANT,
  COMPLIANT_LABEL,
  NOT_COMPLIANT_LABEL,
} from "@/constants/compliance";

const HIGHLIGHT_CONTENT_CLASS = "highlight_content";

const LEVEL_1_USER_STRING = "Level 1 user";

const YES_LABEL = "Yes";
const NO_LABEL = "No";

@Component({
  components: {},
})
export default class VCompanySummary extends Vue {
  levelOneString = LEVEL_1_USER_STRING;

  init = false;

  highlights: TCompanies_Highlight[] = [];

  isLevelOne = null;

  get companyId(): number {
    return Number(this.$route.params.company_id ?? 0);
  }

  mounted() {
    if (!this.init) this.fetchHighlight();
  }

  convertString(s: string): string {
    return s.charAt(0).toUpperCase() + s.slice(1).replaceAll("_", " ");
  }

  async fetchHighlight() {
    if (!this.companyId) return;

    try {
      const { data } = await this.axios.get(API_ROUTES.EXPERT_COMPANIES_HIGHLIGHT(this.companyId));

      if (!data) return;

      this.isLevelOne = data.level_1_user;

      this.highlights = Object.keys(data).map((key) => {
        return { label: this.convertString(key), alias_result: data[key] };
      });
    } finally {
      this.init = true;
    }
  }

  loading = false;

  @Watch("isLevelOne")
  async isLevelOneChanged(value: boolean, prevValue: boolean) {
    if (prevValue === null) return;

    try {
      this.loading = true;

      await this.axios.get(API_ROUTES.EXPERT_COMPANIES_LEVEL_STATUS(this.companyId, Number(value)));
    } finally {
      this.loading = false;
    }
  }

  getAliasResult(result: string | boolean) {
    if (result === COMPLIANT) return COMPLIANT_LABEL;

    if (result === NOT_COMPLIANT) return NOT_COMPLIANT_LABEL;

    if (result === true) return YES_LABEL;

    if (result === false) return NO_LABEL;

    return result || "―";
  }

  getClasses(result: string) {
    return {
      [`${HIGHLIGHT_CONTENT_CLASS}-success`]: result === COMPLIANT,
      [`${HIGHLIGHT_CONTENT_CLASS}-error`]: result === NOT_COMPLIANT,
    };
  }
}
